import {
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime)

function TXItem(key, tx, executed) {
  const currentTime = dayjs();
  const txTime = dayjs.unix(tx.timeStamp);

  function addrToHyperlink(addr) {
    return <a target='_blank' href={`https://etherscan.io/address/${addr}`}>
      {addr}
    </a>
  }

  function appendComma(text, index, length) {
    if (index < length - 1) {
      return text + ", "
    } else {
      return text
    }
  }

  function parseForAddr(txData) {
    if (txData && txData.length && typeof txData != "string") {
      console.log(typeof txData)
      const splitObjs = txData.join(", ").split(", ");
      let prevItemAddr = false;
      const dispObjs = splitObjs.map((dataItem, index) => {
        if (dataItem.startsWith("0x") && dataItem.length == 42) {
          prevItemAddr = true;
          return addrToHyperlink(dataItem)
        } else {
          return <a>{(prevItemAddr ? ", " : "") + appendComma(dataItem)}</a>
        }
      });
      return dispObjs;
    }
    return txData;
  }

  // TODO handle tx.data here to properly do hyperlinks.
  return (
    <Container key={key} style={{ paddingTop: 16, width: "100%" }}>
      <Row style={{ alignItems: "center" }}>
        <Col xs={2}>
          <a target='_blank' href={`https://etherscan.io/tx/${tx.hash}`}>Transaction</a>
          <br />
          {txTime.from(currentTime)}
        </Col>
        <Col xs={8}>
          <Row style={{ paddingBottom: 8 }}>
            {tx.functionCall} to&nbsp;{addrToHyperlink(tx.decodedData[0])}
          </Row>
          <Row>
            Internal transaction: {tx.internalFunc}
          </Row>
          <Row>
            Data:&nbsp;{parseForAddr(tx.internalFuncData)}
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default TXItem;
